import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

let titleSceneF: any = null;
const F = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneF) {
                    AniContainer.removeScene(titleSceneF);
                    titleSceneF = null;
                }

                titleSceneF = AniContainer.create({
                    triggerElement: '.dpu-detail-F .dpu-F-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneF) {
                    AniContainer.removeScene(titleSceneF);
                    titleSceneF = null;
                }
            };
        }
    }, []);
    return (
        <section className={`dpu-detail-F dpu-detail-section ${styles.dpuDetailF}`}>
            <div className={`dpu-F-box ${textEnter ? 'enter' : ''}`}>
                <p className='title'>{t('secF2_title')}</p>
                <p className='desc'>{t('secF2_desc')}</p>
            </div>
        </section>
    );
};

export default F;
